'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const getTextWidth=require('../../../../dist-es6/client/utilities/getTextWidth');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const MinimumIntervalWidthInPixels=2;
const DefaultAxisLabelMargin=14;let

IntervalPlotterDirective=function(_BaseControllerBacked){_inherits(IntervalPlotterDirective,_BaseControllerBacked);function IntervalPlotterDirective(){_classCallCheck(this,IntervalPlotterDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(IntervalPlotterDirective,[{key:'objectBindings',get:function()
{
return['intervals','intervalHeight','labelFormatter','plotArea','horizontalAxis','labelFontStyle','verticalMargin','intervalTopY','doNotClip','alwaysRedraw','selectedInterval'];
}},{key:'textBindings',get:function()
{
return['class','intervalColor','mask','leftAxisLabel','leftAxisLabelMargin'];
}},{key:'controller',get:function()

{
return IntervalPlotterController;
}}]);return IntervalPlotterDirective}(BaseControllerBackedDirective);let


IntervalPlotterController=function(){_createClass(IntervalPlotterController,null,[{key:'$inject',get:function()
{
return['$scope','$element','$compile'];
}}]);

function IntervalPlotterController($scope,$element,$compile){var _this2=this;_classCallCheck(this,IntervalPlotterController);
this._labelMargin={
top:1,
left:4};


this._$scope=$scope;
this._$element=$element;
this._$compile=$compile;

this.labelFontSize=_.exists(this.labelFontStyle)?Number.parseInt(this.labelFontStyle.split(' ')[1].split('px')[0]):void 0;
this.leftAxisLabelMargin=_.exists(this.leftAxisLabelMargin)?parseInt(this.leftAxisLabelMargin,10):DefaultAxisLabelMargin;
this.alwaysRedraw=_.exists(this.alwaysRedraw)?!!this.alwaysRedraw:!1;

$scope.$watch('controller.plotArea',function(){
if(_.exists(_this2.plotArea)){
_this2.plotArea.registerPlotter(_this2);
}
});


if(this.selectedInterval!==void 0){
$scope.$watch('controller.selectedInterval',function(newInterval){
for(const int of _.flatten(_this2._plottedIntervals)){
d3.select(int).
classed('selected',_.get(int,'__data__.interval')===newInterval);
}
});
}
}IntervalPlotterController.prototype.

























_plotIntervals=function _plotIntervals(element,intervalInfo){
let withoutToolTips=element.selectAll(`rect`).
data(intervalInfo).
enter().
append(`rect`).
attr(this._baseRectangleAttributes);
return _.exists(this.labelFormatter)?
withoutToolTips.attr(this._baseTooltipAttributes):
withoutToolTips;
};IntervalPlotterController.prototype.

_insertTspans=function _insertTspans(intervalInfo){var _this3=this;
let lines=intervalInfo.label.split('\n');
if(lines!==void 0){
let textElement=d3.select(this);
let margin=5;

let widthOfLargestLine=_.max(lines.map(function(l){return getTextWidth(l,_this3.labelFontStyle)}))+margin*2;
let xPlacement=Math.min(Math.max(intervalInfo.xPos,0),intervalInfo.svgWidth-widthOfLargestLine);
let xPosDifference=intervalInfo.xPos<0?intervalInfo.xPos:0;

let classes=[];

if(widthOfLargestLine-xPosDifference>intervalInfo.widthOnScreen||xPlacement<textElement.attr('x')){
classes.push('hide');
classes.push('too-long');
}

for(let i=0;i<lines.length;i++){
textElement.append('tspan').
text(lines[i]).
attr('x',xPlacement).
attr('dy',i>0?'1.2em':0).
attr('class',classes.join(' '));
}
}
};IntervalPlotterController.prototype.

_plotLabels=function _plotLabels(element,intervalInfo){
return element.selectAll('text').
data(intervalInfo).
enter().
append('text').
attr(this._baseRectangleAttributes).
style(this._baseTextLabelAttributes).
each(this._insertTspans);
};IntervalPlotterController.prototype.

redraw=function redraw(){var _this4=this;
if(!_.exists(this.horizontalAxis)||!_.exists(this.horizontalAxis.scale)){
return;
}

const svgContainer=d3.select(this.plotArea.svgElement);
const intervalGroup=svgContainer.append('g').attr({
class:this.class,
transform:`translate(0, ${this.plotArea.graphAreaBoundaries.top})`,
mask:`url(#${this.mask}-${this.plotArea.id})`});


const intervals=_.isArray(this.intervals)?this.intervals:_.compact([this.intervals]);

if(!_.exists(intervals)||intervals.length===0){
return;
}

let actualIntervalHeight=_.exists(this.intervalHeight)?
this.intervalHeight:
this.plotArea.graphAreaDimensions.height;

let intervalTopY=this.plotArea.graphAreaDimensions.height-actualIntervalHeight;

if(_.exists(this.intervalTopY)){
actualIntervalHeight-=this.intervalTopY;
intervalTopY=this.intervalTopY;
}

if(_.exists(this.verticalMargin)){
actualIntervalHeight-=this.verticalMargin*2;
intervalTopY+=this.verticalMargin;
}

if(_.exists(this.leftAxisLabel)&&this.leftAxisLabel!==''){
intervalGroup.
append('text').
attr({
y:intervalTopY+actualIntervalHeight/2,
x:0,
class:'interval-axis-label'}).

text(this.leftAxisLabel);
}

let intervalInfos=intervals.map(function(interval){
const xPos=_this4.horizontalAxis.scale(interval.start.getTime());
const xEnd=_this4.horizontalAxis.scale(interval.end.getTime());
const widthOnScreen=Math.max(xEnd-xPos,MinimumIntervalWidthInPixels);
const svgWidth=_this4.plotArea.dimensions.width;

const width=_this4.doNotClip?widthOnScreen:xPos<_this4.horizontalAxis.offset?
widthOnScreen+xPos-_this4.horizontalAxis.offset:
xPos+widthOnScreen>svgWidth?
svgWidth-xPos:
widthOnScreen;

const info={
interval:interval,
xPos:xPos,
widthOnScreen:widthOnScreen,
width:width,
svgWidth:svgWidth,
fontSize:_this4.labelFontSize};

if(_.exists(_this4.labelFormatter)){
info.label=_this4.labelFormatter(interval);
}
return info;
}).filter(function(intervalInfo){return intervalInfo.width>=0});

this._plottedIntervals=this._plotIntervals(intervalGroup,intervalInfos).
attr({
height:actualIntervalHeight,
y:intervalTopY,
class:this.class});


if(this.selectedInterval!==void 0){
const _self=this;
this._plottedIntervals.on('focus',function(d){
_self._$scope.$evalAsync(function(){
_self.selectedInterval=d.interval;
});
});
}

if(_.exists(this.intervalColor)){
this._plottedIntervals.style('fill',this.intervalColor);
}

if(_.exists(this.labelFontStyle)&&_.exists(this.labelFormatter)){
this._plotLabels(intervalGroup,intervalInfos).
attr({
class:`${this.class}-label`,
transform:`translate(${this._labelMargin.left}, ${intervalTopY+this._labelMargin.top+this.labelFontSize})`});

}

if(this._childScope){
this._childScope.$destroy();
}

this._childScope=this._$scope.$new();

this._compiledHtml=this._$compile(this.plotArea.svgElement)(this._childScope);
};_createClass(IntervalPlotterController,[{key:'_baseTooltipAttributes',get:function(){return{"pulsar-tooltip":!0,"pulsar-tooltip-anchor":function(i){return _getTooltipAnchorSide(i,'left','bottomLeft')},"pulsar-tooltip-align-from":function(i){return _getTooltipAnchorSide(i,'right','topLeft')},"pulsar-tooltip-text":function(intervalInfo){return intervalInfo.label}}}},{key:'_baseRectangleAttributes',get:function(){var _this5=this;return{tabindex:-1,x:function(intervalInfo){return _this5.doNotClip?intervalInfo.xPos:Math.max(intervalInfo.xPos,_this5.horizontalAxis.offset)},width:function(intervalInfo){return intervalInfo.width}}}},{key:'_baseTextLabelAttributes',get:function(){return{"font-size":`${this.labelFontSize}px`,"line-height":'2ex'}}}]);return IntervalPlotterController}();


const _getTooltipAnchorSide=function(intervalInfo,nearEdgeSide,defaultSide){return(
intervalInfo.xPos/intervalInfo.svgWidth>0.85||intervalInfo.xPos>350&&intervalInfo.svgWidth-intervalInfo.xPos<350?
nearEdgeSide:
defaultSide)};

module.exports=IntervalPlotterDirective;
//# sourceMappingURL=intervalPlotterDirective.js.map
